module.exports = __webpack_public_path__ + "assets/img/travel-day8.6e636e22.png";